import OrgSettingsConstants from 'constants/OrgSettingsConstants'
import { captureException, captureResponseException } from 'utils/SentryHelpers'

class OrgSettingsActionCreators extends Marty.ActionCreators {

  updateIcon(orgId, file) {
    this.dispatch(OrgSettingsConstants.UPLOAD_WIDGET_ICON_STARTED, orgId, file)
    return this.app.sources.OrgPropertiesAPI.uploadOrgImage(orgId, file).then((res) => {
      if (res.status === 200) {
        const iconUrl = res.body.attachmentUrl
        this.dispatch(OrgSettingsConstants.UPLOAD_WIDGET_ICON_FINISHED, ['theme', 'iconUrl'], iconUrl)
      } else {
        captureResponseException(res)
        this.dispatch(OrgSettingsConstants.UPLOAD_WIDGET_ICON_FAILED)
      }
    }).catch((error) => {
      captureException(error)
      this.dispatch(OrgSettingsConstants.UPLOAD_WIDGET_ICON_FAILED)
    })
  }

  updateOrgSettings(orgSettings) {
    this.dispatch(OrgSettingsConstants.ORG_SETTINGS_UPDATED, orgSettings)
  }
}

export default OrgSettingsActionCreators



// WEBPACK FOOTER //
// ./src/scripts/actions/OrgSettingsActions.js